import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Printer, PrintOptions } from '@ionic-native/printer/ngx';
import { ToastService } from 'src/app/core/toast.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';

@Component({
  selector: 'app-gerar-relatorio-produtos',
  templateUrl: './gerar-relatorio-produtos.page.html',
  styleUrls: ['./gerar-relatorio-produtos.page.scss'],
})
export class GerarRelatorioProdutosPage implements OnInit {


  constructor(private pedidoapi: PedidoService, private router: Router, public global: GlobalService, private printer: Printer, private route: ActivatedRoute, private toast: ToastService, private apipedido: PedidoService) { }

  tipoPedido;
  data1semhora;
  data2semhora;
  tipoStatus;
  pedidos;
  pedido;

  stringStatus;
  valorTotal = 0;
  qtdTotal = 0;

  padesquerda = 0;
  paddireita = 1;

  impressao = false;


  ngOnInit() {

    const idParam = this.route.snapshot.paramMap.get('data');
    const idParam1 = this.route.snapshot.paramMap.get('data2');
    const idParam2 = this.route.snapshot.paramMap.get('status');
    const idParam3 = this.route.snapshot.paramMap.get('tipo');

    this.tipoPedido = idParam3;
    this.data1semhora = this.converterData(idParam.slice(0, -6));
    this.data2semhora = this.converterData(idParam1.slice(0, -6));
    this.tipoStatus = idParam2;


    this.loadPedidos(idParam, idParam1, idParam2);
    this.tituloStatus(idParam2);


  }


    getFilteredOutput(evento, dt){
      this.pedidos = dt.filteredValue;
    }

  tituloStatus(stts) {
    const status = stts;
    switch (status) {
      case '1':
        this.stringStatus = "Abertos"
        break;

      case '2':
        this.stringStatus = "Em Emissão"
        break;

      case '3':
        this.stringStatus = "Em produção"
        break;

      case '4':
        this.stringStatus = "Em Entrega"
        break;


      case '5':
        this.stringStatus = "Finalizados"
        break;


      case '6':
        this.stringStatus = "Cancelados"
        break;
    }
  }
  
  converterData(data) {
    let data1 = data.slice(0, -4);
    let data2 = data.slice(6);
    let data3 = data.slice(4);
    let data4 = data3.slice(0, -2);
    return data1 + '-' + data4 + '-' + data2;
  }

  pad(pad, str, padLeft) {
    if (typeof str === 'undefined')
      return pad;
    if (padLeft) {
      return (pad + str).slice(-pad.length);
    } else {
      return (str + pad).substring(0, pad.length);
    }
  }

  async loadPedidos(data1, data2, status) {
    if (this.tipoPedido === "mes" || this.tipoPedido === "mes3" || this.tipoPedido === "mes6", this.tipoPedido = "personalizado") {
      const data1aux = data1;
      const data2aux = data2;
      data1 = data2aux;
      data2 = data1aux;
    }
      await this.pedidoapi.relatorioProd(data1, data2, status, "todos").then(res => {
        this.pedidos = res;
      }).catch(async err => {
        console.log('err', err);
      });
    
  }

  imprimir(){
    for (let index = 0; index < this.pedidos.length; index++) {
      const element = this.pedidos[index];
      this.qtdTotal = +element.quantidade + +this.qtdTotal;
      this.valorTotal = +element.valor + +this.valorTotal;
    }
    this.impressao = true;
  }

  sair_impressao(){
    this.qtdTotal = 0;
    this.valorTotal = 0;
    this.impressao = false;
  }



  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  print() {
    document.getElementById('sair').style.display = 'none';
    document.getElementById('imprimir').style.display = 'none';


    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // tslint:disable-next-line: prefer-const
      let options: PrintOptions = {
        name: 'MyDocument',
        duplex: true,
        orientation: 'landscape',
        monochrome: true
      };

      this.printer.print().then(async res => {
        await this.delay(4000);
        document.getElementById('sair').style.display = 'block';
        document.getElementById('imprimir').style.display = 'block';

      }).catch(async err => {
        document.getElementById('sair').style.display = 'block';
        document.getElementById('imprimir').style.display = 'block';
        console.log('err', err);
      });
    } else {
      window.print();
      document.getElementById('sair').style.display = 'block';
      document.getElementById('imprimir').style.display = 'block';
    }



  }

}

